import { retriveAllCaseFlags } from '../../../lib/systemData'
import { useState } from 'react'
import CheckboxCell from '../../common/interactive/CheckboxCell'
import classes from './Exceptions.module.css'
import ExceptionsGroupItem from './ExceptionsGroupItem'
import { objectHasOwnProperty } from '../../../lib/script'
import ExceptionsGroupSelectAll from './ExceptionsGroupSelectAll'

export default function ExceptionsGroup({item, exceptionValues, selectCheckBoxHandler, selectAllHandler, workQ}) {

    const [groupTotals, setGroupTotals] = useState(0)
    

    function countSelectedFlagsPerGroup() {
        let number = 0

        // if (workQ && workQ.exceptions_filters) {      
        //     item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key)).forEach(element => {
        //         if (
        //             workQ.exceptions_filters[element.key] && 
        //             (!exceptionValues || (exceptionValues.case_flags && !objectHasOwnProperty(exceptionValues.case_flags, element.key))) // check if filter doesn't appear in the store, if it is there, don't add it!
        //         ) {
        //             number = number + 1
        //         } 
                
        //     });
        // }
        let truthArray = []
        if (exceptionValues && exceptionValues.case_flags && Object.keys(exceptionValues?.case_flags).length && retriveAllCaseFlags()) {   
            for (const [key, value] of Object.entries(exceptionValues?.case_flags)) {   

                let group = item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key))
                
                group.forEach((item) => {
                    truthArray.push(exceptionValues?.case_flags[item.key])
                })
                
                if (group) {
                    if (group.find(gr => gr.key == key)) {                    
                        if (value) {
                            number = number + 1
                        }
                    } 
                }
            }
        }

        

        return number
    }

    function selectAllHandlerMiddleware(value) {
        
        if (value?.data?.value) {
            setGroupTotals(item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key)).length)
        } else {
            setGroupTotals(0)
        }

        if (selectAllHandler) {
            selectAllHandler(value)
        }
    }

    return <>
        {item.filters && item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key)) && item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key)).length > 0 && <div key={item.group} className={classes.group}>
            <div className={classes.group_header}>
                <div className={classes.group_header_inner}>
                    {item.group}
                    {/* <span className={classes.selectd}>{countSelectedFlagsPerGroup() ? `(${countSelectedFlagsPerGroup()} selected)` : '' }</span> */}
                    <span className={classes.selectd}>{`(${groupTotals ? groupTotals : countSelectedFlagsPerGroup()} selected)`}</span>
                    {/* <span className={classes.selectd}></span> */}
                </div>
                <ExceptionsGroupSelectAll selectAllHandlerMiddleware={selectAllHandlerMiddleware} item={item} exceptionValues={exceptionValues} workQ={workQ}/>
            </div>
            <div className={classes.group_filters}>
                {item.filters && item.filters.filter(elem => objectHasOwnProperty(workQ.exceptions_filters, elem.key)).map(filter => (
                    <div key={filter.key} className={classes.group_filter_item}>
                        <ExceptionsGroupItem filter={filter} exceptionValues={exceptionValues} selectCheckBoxHandler={selectCheckBoxHandler} workQ={workQ} />
                    </div>
                ))}
            </div>
        </div>}
    </>
}